export default {
  set(name: string, value: unknown): void {
    let val = undefined;
    if (typeof value === 'string') {
      val = value as string;
    } else {
      val = JSON.stringify(value);
    }
    localStorage.setItem(name, val);
  },

  get<T>(name: string): T | null {
    const raw = localStorage.getItem(name);
    if (!raw) return null;
    try {
      const data: T = JSON.parse(raw);

      if (typeof data === 'boolean' || data) {
        return data;
      }
      return null;
    } catch (e) {
      // @ts-ignore
      return raw;
    }
  },

  delete(name: string): void {
    localStorage.removeItem(name);
  },
};
